import { useSubscription } from 'services/hooks';
import {
  PersonalUserStudioExportLimitDialog,
  ProUserStudioExportLimitDialog,
} from './components';

interface StudioExportLimitDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Dialog that should be shown for personal and pro users on exceeding the studio
 * export limit.
 */
const StudioExportLimitDialog = ({
  onClose,
  isOpen,
}: StudioExportLimitDialogProps) => {
  const { isPersonalAccount, isProAccount } = useSubscription();

  if (isPersonalAccount)
    return (
      <PersonalUserStudioExportLimitDialog isOpen={isOpen} onClose={onClose} />
    );

  if (isProAccount)
    return <ProUserStudioExportLimitDialog isOpen={isOpen} onClose={onClose} />;

  return null;
};

export default StudioExportLimitDialog;
